/******************************************************************************
 * Copyright 2023 TypeFox GmbH
 * This program and the accompanying materials are made available under the
 * terms of the MIT License, which is available in the project root.
 ******************************************************************************/
export * from './grammar-config.js';
export * from './language-meta-data.js';
//# sourceMappingURL=index.js.map